import { useMemo, useState } from "react";
import { Card, Table, Tag, Tooltip, Input } from "antd";
import { SearchOutlined, StopOutlined } from "@ant-design/icons";
import GlobalPopupKonfirm from "../../../../commonComponents/GlobalPopupKonfirm";
import { sourceTag } from "../../../../../constantsFactory/quoteOfTheDay";

// What has actually been published, newest first. The daily pick keeps roughly
// nine months of entries, which is also what stops a quote repeating.
function QuoteHistoryTable({ history, isDarkMode, onBlockQuote }) {
  const [search, setSearch] = useState("");

  const rows = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return history;
    return history.filter((h) =>
      `${h?.quote || ""} ${h?.quoteEn || ""} ${h?.author || ""}`
        .toLowerCase()
        .includes(term)
    );
  }, [history, search]);

  const columns = [
    { title: "Data", dataIndex: "date", key: "date", width: 110 },
    {
      title: "Citimi",
      dataIndex: "quote",
      key: "quote",
      render: (value, row) => (
        <div className="quoteCell">
          <span className="text">{value}</span>
          {!!row?.quoteEn && <span className="original">{row.quoteEn}</span>}
          {!!row?.author && <span className="author">— {row.author}</span>}
        </div>
      ),
    },
    {
      title: "Rasti",
      dataIndex: "occasion",
      key: "occasion",
      width: 180,
      render: (value) => (value ? <Tag color="gold">{value}</Tag> : "—"),
    },
    {
      title: "Burimi",
      dataIndex: "source",
      key: "source",
      width: 150,
      render: (value) => {
        const tag = sourceTag(value);
        return <Tag color={tag.color}>{tag.label}</Tag>;
      },
    },
    {
      title: "",
      key: "actions",
      width: 60,
      render: (_, row) =>
        row?.source === "wish" ? null : (
          <GlobalPopupKonfirm
            okText="Po"
            cancelText="Jo"
            title="Ta bllokojmë këtë citim që të mos dalë më?"
            onConfirm={() => onBlockQuote(row)}
            Button={
              <Tooltip title="Blloko">
                <StopOutlined />
              </Tooltip>
            }
          />
        ),
    },
  ];

  return (
    <Card
      className={`citimiCard ${isDarkMode ? "dark" : ""}`}
      title={`Historiku (${history.length})`}
    >
      <div className="citimiFilters">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="Kërko sipas tekstit ose autorit"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Table
        rowKey={(row) => row?.isoDate || row?.quoteId}
        size="small"
        dataSource={rows}
        columns={columns}
        pagination={{ pageSize: 10, showSizeChanger: false }}
      />
    </Card>
  );
}

export default QuoteHistoryTable;
